import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const StackSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default StackSVG;
